import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'components/components.module';
import { TestUiNutrientsPage } from './test-ui-nutrients';

@NgModule({
  declarations: [
    TestUiNutrientsPage
  ],
  imports: [
    CommonModule,
    ComponentsModule
  ]
})
export class TestUiNutrientsPageModule {}
